export const siteConfig = {
  name: 'Bedrock Toolchest',
  version: '3.1',
  tagline: 'Take full control of your Minecraft Bedrock worlds',
  description: 'A free desktop app for Windows and Linux that edits your Minecraft Bedrock worlds. Change game rules, edit inventories and villager trades, prune chunks on a real map of your world, fix villages, manage add-ons, edit your Realms and servers, and more. One file, no install.',
  discordUrl: 'https://discord.mygen.co.uk',
  kofiUrl: 'https://ko-fi.com/mygen',
  platform: 'Windows 10+ and Linux x64',
  license: 'CC BY-ND',
};
